(function importImagesProcessControllerDefinition() {
    'use strict';

    angular.module('ImportImagesProcess')
        .controller('ImportImagesProcessFindController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'importImagesProcessService', 'authExtend', 'storageService', 'documentTypeService', 'importImagesStateService', '$uibModal', 'alerts',
    function importImagesProcessController($scope, config, $state, $translate, errors, importImagesProcessService, authExtend, storageService, documentTypeService, importImagesStateService, $modal, alerts) {

        $scope.accesPurge = authExtend.isInRole('PROCESSIMAGES PURGE');
        $scope.optionsStates = [];

        $scope.load = function () {

            $scope.orders = [
                   { value: 'creationDate ASC', description: 'CreationDate ASC' },
                   { value: 'creationDate DESC', description: 'CreationDate DESC' },
                   { value: 'fileName ASC', description: 'Name ASC' },
                   { value: 'fileName DESC', description: 'Name DESC' }
            ];

            $scope.order = $scope.orders[1];

            $scope.item = { id: null, name: "All" };

            $scope.find = storageService.getImagesProcessFilter();

            if (jQuery.isEmptyObject($scope.find)) {
                $scope.find = {
                    dateFrom: null,
                    dateTo: null,
                    showNoData: false,
                    selectedImportState: null,
                    documentType: $scope.item,
                };

                storageService.setImagesProcessFilter($scope.find);
            }

            $scope.data = {
                currentPage: 1,
                totalItems: 0,
                itemsPerPage: 15,
                from: 0
            };

            $translate(['PaginationNext', 'PaginationPrev', 'PaginationLastFem', 'PaginationFirstFem'])
                .then(function (translated) {
                    $scope.paginatorTranslations = {
                        nextText: translated.PaginationNext,
                        previousText: translated.PaginationPrev,
                        lastText: translated.PaginationLastFem,
                        firstText: translated.PaginationFirstFem
                    };
                });

            documentTypeService.getFunctionsTypes(['IMPORT IMAGES PROCESS READ'])
                .then(function (result) {
                    $scope.optionsDocumentTypes = result.sort(function (a, b) {
                        return a.name.localeCompare(b.name);
                    });
                    result.splice(0, 0, $scope.item);
                    $scope.find.documentType = $scope.optionsDocumentTypes[0];
                }, function (error) {
                    errors.showError(error);
                });

            importImagesStateService.getAll().then(function (result) {
                result.splice(0, 0, $scope.item);
                $scope.optionsStates = result;
                $scope.find.selectedImportState = $scope.optionsStates[0];
            }, function (error) {
                errors.showError(error);
            });
        }

        $scope.Purge = function (impor) {
            return $translate(['ImportProcessPurge', 'ImportProcessByIdeConfirmationMessage', 'ImportProcessConfirmationContinue', 'Yes', 'No']).then(function (translated) {
                var message = translated.ImportProcessByIdeConfirmationMessage + translated.ImportProcessConfirmationContinue;
                return alerts.confirm(translated.ImportProcessPurge, message, translated.Yes, translated.No).then(function getOk(result) {
                    if (result) {
                        return importImagesProcessService.PurgeById(impor.id).then(function getOk(result) {
                            impor.isPurged = true;
                        }, function getError(error) {
                            errors.showError(error);
                        });
                    }
                });
            });
        };

        $scope.PurgeAll = function () {
            var modalController = function ($scope, $modalInstance, $translate) {
                //Hack to show datepicker menu
                $('ul.dropdown-menu').css('z-index', '9999');

                $scope.showConfirmation = false;

                $scope.date = new Date();
                $scope.organizationalUnitId;
                $scope.organizationalUnitName;
                $scope.dateTo = new Date();
                $scope.count = 0;
                
                $scope.selectionStates = [];

                // Watch states for changes
                $scope.$watch('optionsStates|filter:{selected:true}', function (nv) {
                    $scope.selectionStates = nv.map(function (state) {
                        return state.id;
                    });
                }, true);

                $scope.cancel = function () { $modalInstance.close(); }
                $scope.ok = function () {
                    $('.sweet-alert').appendTo("body");
                    if ($scope.selectionStates.length < 1) {
                        return $translate(['ImportProcessPurge', 'ImportProcessPurgeNoState', 'Ok']).then(function (translated) {
                            return alerts.alert(translated.ImportProcessPurge, translated.ImportProcessPurgeNoState, translated.Ok);
                        });
                    }

                    return importImagesProcessService.getPurgeCount($scope.date, $scope.selectionStates).then(function getOk(result) {
                        if (result > 0) {
                            $scope.count = result;
                            return $translate(['ImportProcessPurge', 'ImportProcessConfirmationMessage', 'ImportProcessConfirmationContinue', 'Yes', 'No']).then(function (translated) {
                                var message = translated.ImportProcessConfirmationMessage.replace("{count}", $scope.count) + translated.ImportProcessConfirmationContinue;
                                return alerts.confirm(translated.ImportProcessPurge, message, translated.Yes, translated.No).then(function getOk(result) {
                                    if (result) {
                                        return importImagesProcessService.Purge($scope.date, $scope.selectionStates).then(function getOk(result) {
                                            $modalInstance.close();
                                            location.reload();
                                        }, function getError(error) {
                                            errors.showError(error);
                                        });
                                    }
                                });
                            });
                        }
                        else {
                            return $translate(['ImportProcessPurge', 'ImportProcessPurgeNoTar', 'Ok']).then(function (translated) {
                                return alerts.alert(translated.ImportProcessPurge, translated.ImportProcessPurgeNoTar, translated.Ok);
                            });
                        }

                    }, function getError(error) {
                        errors.showError(error);
                    });
                };


            };
            modalController.$inject = ['$scope', '$modalInstance', '$translate'];

            function openModal() {
                var modalInstance = $modal.open({
                    templateUrl: '/app/views/import-images-process/partial-purge.html',
                    controller: modalController,
                    size: 'md',
                    scope: $scope,
                    backdrop: 'static',
                    keyboard:false
                });

                var result = modalInstance.result;
                return result;
            }

            openModal();



        };

        $scope.findAction = function () {
            $scope.items = [];
            $scope.find.showNoData = false;
            storageService.setImagesProcessFilter($scope.find);

            return importImagesProcessService.get($scope.find.selectedImportState, $scope.find.documentType.id, $scope.find.dateFrom, $scope.find.dateTo, $scope.data.currentPage, $scope.data.itemsPerPage, $scope.order.value).then(function getOk(result) {
                $scope.items = result.value;

                $scope.data.totalItems = result.totalCount;
                $scope.data.from = result.from;

                if ($scope.items.length === 0)
                    $scope.find.showNoData = true;

                if ($scope.items.length === 0)
                    $scope.find.showNoData = true;

            }, function getError(error) {
                errors.showError(error);
            });
        };

        $scope.view = function (processImage) {
            storageService.setImagesProcessFilter($scope.find);
            $state.go('import-images-process-detail', { id: processImage.id });
        };

        $scope.load();
        $scope.findAction();
    }
        ]);
})();